import React, { useEffect, useState } from "react";
import * as styles from "./header.css";
import { SideMenu } from "../Top/components/SideMenu/SideMenu";
import logoImage from "../../../../assets/top/logonameonly.png";

export type HeaderNavItem = {
  label: string;
  path: string;
};

export type HeaderProps = {
  logoUrl: string;
  navItems: HeaderNavItem[];
};

export const Header: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > lastScrollY && scrollTop > 100) {
        setIsVisible(true);
      } else if (scrollTop < lastScrollY && scrollTop < 100) {
        setIsVisible(false);
      }

      if (scrollTop > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      setLastScrollY(scrollTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <header
        className={`${styles.headerContainer} ${isVisible ? styles.show : styles.hide} ${
          isScrolled ? styles.scrolled : ""
        }`}
      >
        <img src={logoImage} alt="Logo" className={styles.logo} />
        <button 
          className={styles.menuButton}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="メニューを開く"
        >
          <span className={styles.menuLine} />
          <span className={styles.menuLine} />
          <span className={styles.menuLine} />
        </button>
      </header>
      <SideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
    </>
  );
};

export default Header;
